<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper" ref="field">
        <div class="row no-wrap items-end relative-position q-input "
             :class="[!hasError ? `text-${color}` : '', {
                'q-if-error text-negative': hasError,
                'q-if-has-label': label,
                'q-if': label && !hasError,
                'q-if-hide-underline': hideUnderline
             }]">
            <div class="q-if-inner col row no-wrap relative-position">
                <div class="q-if-label ellipsis absolute self-start"
                     :class="{ 'q-if-label-above': displayValue || this.$slots.default }">
                    {{ label | capitalize }}
                </div>
                <div class="relative-position">
                    <slot><span v-html="displayValue" class="capitalize"></span></slot>
                </div>
            </div>
        </div>
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import moment from 'moment'
    import {date} from 'quasar-framework'

    export default {
        name: 'VDisplay',

        mixins,

        props: {
            innerLabel: String,
            negativeLabel: String,
            options: {
                type: Array,
                default() {
                    return []
                }
            },
            format: {
                type: String
            },
            hideUndeline: Boolean
        },

        computed: {
            displayValue() {
                if (this.options.length > 0) {
                    var result = this.options.filter(option => option.value == this.value)
                    if (result.length === 0) return
                    return result[0].label
                }
                if (this.value && (this.format || moment(this.value, 'DD/MM/YYYY', true).isValid()))
                    return moment(this.value, 'DD/MM/YYYY').format(this.format || this.defaultFormat)
                if ((this.value === true || this.value === false) || this.negativeLabel)
                    return this.value ? this.innerLabel : this.negativeLabel
                if (this.value)
                    return this.value.replace(/(?:\r\n|\r|\n)/g, '<br />')
                return this.$t('not_available')
            },

            defaultFormat() {
                return this.$t('date_format')
            }
        },

        mounted() {
            this.$refs.field.$refs.QField.__registerInput({$options: {}})
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VDisplay.vue